import { clientApiAxiosFetch } from '@/hooks/client-api-fetch'

import { getAuthSession } from './auth-session-service'

interface CreateFeedbackPayload {
  status: boolean
}
interface CreateFeedbackParams {
  type: string
  message: string
  files?: File[]
}
export async function createFeedbackService({ message, type, files = [] }: CreateFeedbackParams) {
  if (!type) {
    throw new Error('Type is required')
  }

  if (!message) {
    throw new Error('Message is required')
  }

  const formData = new FormData()
  formData.append('message', message)
  formData.append('type', type)
  // Field name MUST be 'files' to match the backend multipart contract (POST /v1/feedbacks)
  files.forEach((file) => {
    formData.append('files', file)
  })

  const fullUrl = `${process.env.NEXT_PUBLIC_API_URL}/v1/feedbacks`
  const session = await getAuthSession()

  const config = {
    method: 'POST',
    url: fullUrl,
    data: formData,
    headers: {
      'content-type': 'multipart/form-data',
      Authorization: `Bearer ${session?.jwtToken}`,
    },
  }

  const { data, ok } = await clientApiAxiosFetch<CreateFeedbackPayload>({ fullUrl, config })

  return {
    data,
    ok,
  }
}
